import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useBadgeList = (params?: any) => {
  return useQuery({
    queryKey: ['badge-list', params],
    queryFn: async () => {
      const res = await request.get('/course-badge', { params });
      return res.data;
    }
  });
};
